import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { FlexColumn } from "components/rui/layout";
import PageSection from "components/rui/page-components/PageSection";
import { Body } from "components/rui/typography";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";

const BREAK_POINT = "1130px";

const ContentWrapper = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  margin-top: calc(var(--section-gap) * -1);
  b {
    font-weight: 900;
  }
  @media (max-width: ${BREAK_POINT}) {
    margin-top: calc(var(--section-gap-mobile) * -1);
    flex-direction: column;
    align-items: unset;
  }
`;

const imageStyles = css`
  width: 648px;
  height: 420px;
  flex-shrink: 0;
  @media (max-width: ${BREAK_POINT}) {
    height: auto;
    width: auto;
    max-width: 640px;
  }
`;

const Quote = styled.q`
  color: var(--primary-bg);
  font-family: var(--headerFontFamily);
  font-size: 32px;
  font-weight: 500;
  line-height: 150%;
  b {
    color: var(--blue-500);
  }
  @media (max-width: 600px) {
    font-size: 24px;
  }
`;

const TestimonySection = ({ imageSrc, imageAlt, quote, name, company }) => {
  return (
    <PageSection>
      <ContentWrapper>
        <GatsbyImage
          image={getImage(imageSrc)}
          alt={imageAlt}
          className={imageStyles}
          loading="lazy"
          objectFit="contain"
        />
        <FlexColumn gap="48px">
          <Quote>{quote}</Quote>
          <Body>
            <b>{name}</b>, {company}
          </Body>
        </FlexColumn>
      </ContentWrapper>
    </PageSection>
  );
};

export default TestimonySection;
